import React from "react";
import { Page, PageHeader } from "components/ui/Page";
import { PageColumn, EvenThirdsLayout } from "components/ui/PageColumns";
import { LargeSpacer } from "components/ui/VerticalSpacers";
import { ViewAsCard } from "components/cards/ViewAsCard";
import { DelegateStudentsCard } from "components/cards/DelegateStudentsCard";
import ActiveServiceAlerts from "components/ServiceAlerts/ActiveServiceAlerts";
import { FindUserAuthsCard } from "components/cards/UserAuths/FindUserAuthsCard";
import IDLookupCard from "components/cards/IDLookupCard";
import { DataSourceVerificationCard } from "components/cards/DataSourceVerificationCard";
import { APITestCard } from "components/cards/APITestCard";
import { DelegateIntroCard } from "../cards/DelegateIntroCard";
import { AcademicDatesCard } from "../cards/AcademicDatesCard";
import { DelegateQuickLinksCard } from "../cards/DelegateQuickLinksCard";

// https://wikihub.berkeley.edu/display/SIS/CalCentral+My+Toolbox+Page
export default function ToolboxPage() {
  return (
    <Page>
      <PageHeader>My Toolbox</PageHeader>
      <LargeSpacer />
      <EvenThirdsLayout>
        <PageColumn>
          <ViewAsCard />
          <DelegateIntroCard />
        </PageColumn>
        <PageColumn>
          <IDLookupCard />
          <DelegateStudentsCard />
        </PageColumn>
        <PageColumn>
          <ActiveServiceAlerts />
          <FindUserAuthsCard />
          <DataSourceVerificationCard />
          <APITestCard />
          <AcademicDatesCard />
          <DelegateQuickLinksCard />
        </PageColumn>
      </EvenThirdsLayout>
    </Page>
  );
}
